<template>
  <div class="ui grid">
    <div class="row">
      <h1 class="ui huge header">{{ $t('welcomeTitle') }}</h1>
    </div>
    <div class="ui divider"></div>
    <div class="row">
      <p class="ui negative message">{{ $t('invalidTestCode') }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: {},
  computed: mapGetters({}),
  methods: {},
  created() {
    this.$store.dispatch('hideLoader');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/NoTest.vue